<template>
  <div class="control">
    <div class="flex-row">
      <label :for="id" class="form-label">{{ label }}</label>

      <div
        v-if="tooltipText"
        class="tooltip-container"
        @mouseenter="open"
        @mouseleave="close"
        @focus="open"
        @blur="close"
        tabindex="0"
      >
        <i class="icon-help fa fa-circle-question"></i>
      </div>
    </div>

    <MultiSelect
      :id="id"
      v-model="model"
      :options="options"
      :placeholder="placeholder"
    />
  </div>
</template>

<script setup>
import { computed, inject } from "vue"
import MultiSelect from "./MultiSelect.vue"

const tooltipApi = inject("tooltip", null)

const props = defineProps({
  id: { type: String, required: true },
  label: { type: String, required: true },
  tooltipText: { type: String, default: "" },

  options: { type: Array, default: () => [] }, // [{label,value}]
  placeholder: { type: String, default: "None" },

  modelValue: { type: Array, default: () => [] }, // selected values
})

const emit = defineEmits(["update:modelValue"])

const model = computed({
  get: () => props.modelValue,
  set: (val) => emit("update:modelValue", val),
})

const open = (event) => {
  if (!tooltipApi || !props.tooltipText) return
  tooltipApi.openTooltip(event.currentTarget, props.tooltipText)
}
const close = () => tooltipApi?.closeTooltip?.()
</script>